import { render, staticRenderFns } from "./LevelAdjustmentList.vue?vue&type=template&id=53a80070&"
import script from "./LevelAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./LevelAdjustmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports